/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import { KFButton, KFCheckboxWithLabel, KFRadio } from "@kf/ic2fx";
import { Tabs, Tab, Box } from "@mui/material";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  ClickAwayListener
} from "@mui/material";
import { useParams } from "react-router-dom";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HeadlinePayEquity from "../../../components/PayEquity/HeadlinePayEquity";
import PayEquityByJobLevel from "../../../components/PayEquity/PayEquityByJobLevel";
import VariablePayReporting from "../../../components/PayEquity/VariablePayReporting";
import Loader from "../../../components/loader";

import ChartIcon from "../../../assets/icons/chart.svg";
import ListIcon from "../../../assets/icons/list.svg";
import FilterIcon from "../../../assets/icons/filter-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { PageView } from "../../../constants/app.constant";
import { RootState } from "../../../store/reducers";
import {
  appConfigThunk,
  countryListThunk,
  reportFiltersThunk,
  resetState,
  setGlobalFilters
} from "../../../store/slices/reportsSlice";

import styles from "./Reports.module.scss";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanelContent = ({ children, value, index }: TabPanelProps) => {
  return (
    <div className={styles.tabContent} hidden={value !== index}>
      {children}
    </div>
  );
};

const ReportsPage = () => {
  const [expandedPanelIndex, setExpandedPanelIndex] = useState<any>(-1);
  const [isFilterSelected, setFilterSelected] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [menuVisible, setMenuVisible] = useState(false);
  const [selectedFilters, setSlectedFilters] = useState<any>({});
  const [pageView, setPageView] = useState(PageView.CHART);

  const params: any = useParams();
  const dispatch = useDispatch();

  const { reports } = useSelector((state: RootState) => {
    return state.content;
  });

  const { countryList, isCountryLoading, globalFilters } = useSelector(
    (state: RootState) => {
      return state.reports;
    }
  );

  const { appConfigs, isAppConfigsLoading } = useSelector(
    (state: RootState) => {
      return state.reports;
    }
  );

  const { filtersList, isFiltersLoading } = useSelector((state: RootState) => {
    return state.reports;
  });

  const handleTabChange = (event: React.SyntheticEvent, tabIndex: number) => {
    setActiveTab(tabIndex);
  };

  const hideFilterMenu = () => {
    setMenuVisible(false);
  };

  const showFilterMenu = () => {
    setMenuVisible(true);
  };

  const handleClickAway = () => {
    if (menuVisible) {
      hideFilterMenu();
    }
  };

  const onApplyFilters = (isOnlyFilter = false) => {
    const {
      CLASS = {},
      COMPENSATIONFACT,
      GRADE = {},
      JOBFAMILY = {},
      JobFamilyType = {},
      REGION = {}
    } = selectedFilters;

    const _CLASS = Object.keys(CLASS).filter((key) => CLASS[key]);
    const _GRADE = Object.keys(GRADE).filter((key) => GRADE[key]);
    const _JOBFAMILY = Object.keys(JOBFAMILY).filter((key) => JOBFAMILY[key]);
    const _JobFamilyType = Object.keys(JobFamilyType).filter(
      (key) => JobFamilyType[key]
    );
    const _REGION = Object.keys(REGION).filter((key) => REGION[key]);
    const _globalFilters = {
      ...globalFilters,
      compensationFactKeys: COMPENSATIONFACT || "-1",
      regionKeys: _REGION.join(",") || "ALL",
      classKeys: _CLASS.join(",") || "ALL",
      gradeKeys: _GRADE.join(",") || "ALL",
      jobFamilyTypeKeys: _JobFamilyType.join(",") || "ALL",
      jobFamilyKeys: _JOBFAMILY.join(",") || "ALL"
    };
    initFilters(_globalFilters, isOnlyFilter);
  };

  const onUpdateFilters = () => {
    const _selectedFilters: any = {};
    filtersList.map((filter) => {
      _selectedFilters[filter.name] =
        filter.name === "COMPENSATIONFACT" ? "" : {};
      filter.value?.map((item: any) => {
        if (filter.name !== "COMPENSATIONFACT") {
          _selectedFilters[filter.name][item.key] =
            (selectedFilters[filter.name] &&
              selectedFilters[filter.name][item.key]) ||
            false;
        }
      });
    });

    _selectedFilters["COMPENSATIONFACT"] =
      selectedFilters["COMPENSATIONFACT"] ||
      `${appConfigs[0].compensationFactKey}`;

    setSlectedFilters({
      ...selectedFilters,
      ..._selectedFilters
    });
  };

  const clearAllFilters = (countryCode = "") => {
    const _selectedFilters: any = {};
    filtersList.map((filter) => {
      _selectedFilters[filter.name] =
        filter.name === "COMPENSATIONFACT" ? "" : {};
      filter.value?.map((item: any) => {
        if (filter.name !== "COMPENSATIONFACT") {
          _selectedFilters[filter.name][item.key] = false;
        }
      });
    });

    setSlectedFilters({
      ...selectedFilters,
      ..._selectedFilters,
      COUNTRY: countryCode
    });
  };

  const initFilters = (filters: any, isOnlyFilter = false) => {
    if (!isOnlyFilter) {
      dispatch(setGlobalFilters(filters));
    }
    dispatch(reportFiltersThunk(filters));
  };

  const initAppConfigs = (selectedCountry: any = {}) => {
    const orgCodes = selectedCountry.company?.map((org: any) => org.orgcode);
    const payload = {
      countryCode: selectedCountry.code,
      orgCodes: orgCodes.join(","),
      language: "en",
      year: 0
    };

    dispatch(appConfigThunk(payload));
  };

  const initCountryList = (clientId: string) => {
    const payload = {
      personId: "1",
      clientId: clientId
    };
    dispatch(countryListThunk(payload));
  };

  const onAccordionChange = (index: number, isCountry = false) => {
    if (expandedPanelIndex === index) {
      setExpandedPanelIndex(null);
    } else {
      setExpandedPanelIndex(index);
    }

    if (isFilterSelected) {
      setFilterSelected(false);
      onApplyFilters(true);
    }
  };

  const onCountryFilterApplied = (countryCode: string) => {
    const selectedCountry = countryList.find(
      (country) => country.code === countryCode
    );
    clearAllFilters(selectedCountry.code);

    initAppConfigs(selectedCountry);
  };

  const getSelectedFilterCount = (category = "") => {
    if (
      selectedFilters[category] &&
      category !== "Çountry" &&
      category !== "COMPENSATIONFACT"
    ) {
      const selectedItems = Object.keys(selectedFilters[category]).filter(
        (item) => selectedFilters[category][item]
      );
      return selectedItems.length ? `(${selectedItems.length})` : "";
    }

    if (category === "COMPENSATIONFACT" && selectedFilters[category]) {
      return `(1)`;
    }

    return "";
  };

  useEffect(() => {
    if (filtersList && filtersList.length) {
      onUpdateFilters();
    }
  }, [filtersList]);

  useEffect(() => {
    if (appConfigs && appConfigs.length) {
      // const clientPaySubmissionKey = appConfigs.map(
      //   (config: any) => config.clientPaySubmissionKey
      // );

      const filters = {
        langKey: appConfigs[0].langKey,
        gradeSetId: "1",
        clientPaySubmissionKey: "13155",
        compensationFactKeys: `${appConfigs[0].compensationFactKey}`,
        regionKeys: "ALL",
        classKeys: "ALL",
        gradeKeys: "ALL",
        jobFamilyTypeKeys: "ALL",
        jobFamilyKeys: "ALL",
        hayPointsMin: 0,
        hayPointsMax: 0
      };

      initFilters(filters);
    }
  }, [appConfigs]);

  useEffect(() => {
    if (countryList && countryList.length) {
      // initAppConfigs(countryList[0]);
      onCountryFilterApplied(countryList[0].code);
    }
  }, [countryList]);

  useEffect(() => {
    if (params?.clientId) {
      initCountryList(params.clientId);
    }
  }, [params]);

  useEffect(() => {
    return () => {
      dispatch(resetState());
    };
  }, []);

  // if (isCountryLoading || isAppConfigsLoading) {
  //   return <Loader />;
  // }

  return (
    <div className={`${styles.reportsContainer} container`}>
      {(isCountryLoading || isAppConfigsLoading) && <Loader />}
      <div className={styles.pageHeader}>
        <ClickAwayListener onClickAway={handleClickAway}>
          <div className={styles.componentContainer}>
            <KFButton
              color="quaternary"
              onClick={showFilterMenu}
              className={styles.filterBtn}
            >
              <FilterIcon />
              Filters
            </KFButton>
            {menuVisible && (
              <div className={styles.filterContainer}>
                <div className={styles.filterHeader}>
                  <div className={styles.title}>Filters</div>
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={hideFilterMenu}
                  >
                    <g clipPath="url(#clip0_665_4755)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.2356 9.68823L5.83581 5.28846C5.48868 4.94133 4.92586 4.94133 4.57873 5.28846C4.2316 5.63559 4.2316 6.1984 4.57873 6.54554L8.9785 10.9453L4.57873 15.3451C4.2316 15.6922 4.2316 16.255 4.57873 16.6022C4.92586 16.9493 5.48868 16.9493 5.83581 16.6022L10.2356 12.2024L14.6354 16.6022C14.9825 16.9493 15.5453 16.9493 15.8924 16.6022C16.2396 16.255 16.2396 15.6922 15.8924 15.3451L11.4927 10.9453L15.8924 6.54554C16.2396 6.1984 16.2396 5.63559 15.8924 5.28846C15.5453 4.94133 14.9825 4.94133 14.6354 5.28846L10.2356 9.68823Z"
                        fill="#243D42"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_665_4755">
                        <rect
                          width="20"
                          height="20"
                          fill="white"
                          transform="translate(0.235352 0.945312)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className={styles.filterBody}>
                  {(isAppConfigsLoading || isFiltersLoading) && <Loader />}

                  <div className="pa-accordion-container">
                    <Accordion
                      expanded={-1 === expandedPanelIndex}
                      onChange={() => {
                        onAccordionChange(-1, true);
                      }}
                    >
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <div className={styles.accordionTitle}>Country (1)</div>
                      </AccordionSummary>
                      <AccordionDetails>
                        {countryList.map((country, index) => {
                          return (
                            <div
                              className="filterItem"
                              key={`country-${country.code}`}
                            >
                              <div className={`radioControl`}>
                                <KFRadio
                                  color="primary"
                                  checked={
                                    selectedFilters.COUNTRY === country.code
                                  }
                                  value={country.code}
                                  onChange={(e: any) => {
                                    setSlectedFilters({
                                      ...selectedFilters,
                                      COUNTRY: e.target.value
                                    });
                                    // setFilterSelected(true);
                                    onCountryFilterApplied(e.target.value);
                                  }}
                                />
                                {country.name}
                              </div>
                            </div>
                          );
                        })}
                      </AccordionDetails>
                    </Accordion>

                    {filtersList.map((filter, index) => {
                      return (
                        <Accordion
                          expanded={index === expandedPanelIndex}
                          key={`acordion-${filter.name}`}
                          onChange={() => {
                            onAccordionChange(index);
                          }}
                        >
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className={styles.accordionTitle}>
                              {filter.name}
                              <span className={styles.filterCount}>
                                {getSelectedFilterCount(filter.name)}
                              </span>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            {filter.value?.map((item: any, index: number) => {
                              if (filter.name === "COMPENSATIONFACT") {
                                return (
                                  <div
                                    className="filterItem"
                                    key={`filter-${filter.name}-${item.key}-${index}`}
                                  >
                                    <div className={`radioControl`}>
                                      <KFRadio
                                        color="primary"
                                        checked={
                                          +selectedFilters[filter.name] ===
                                          item.key
                                        }
                                        value={item.key}
                                        onChange={(e: any) => {
                                          setSlectedFilters({
                                            ...selectedFilters,
                                            [filter.name]: e.target.value
                                          });
                                          setFilterSelected(true);
                                        }}
                                      />
                                      {item.value}
                                    </div>
                                  </div>
                                );
                              } else {
                                return (
                                  <div
                                    className="filterItem"
                                    key={`filter-${filter.name}-${item.key}-${index}`}
                                  >
                                    <KFCheckboxWithLabel
                                      color="primary"
                                      checked={
                                        selectedFilters[filter.name]
                                          ? selectedFilters[filter.name][
                                              item.key
                                            ]
                                          : false
                                      }
                                      label={item.value}
                                      onChange={(e) => {
                                        setSlectedFilters({
                                          ...selectedFilters,
                                          [filter.name]: {
                                            ...selectedFilters[filter.name],
                                            [item.key]: e.target.checked
                                          }
                                        });
                                        setFilterSelected(true);
                                      }}
                                    />
                                    {/* <div className={styles.filterCount}>(10)</div> */}
                                  </div>
                                );
                              }
                            })}
                          </AccordionDetails>
                        </Accordion>
                      );
                    })}
                  </div>
                </div>

                <div className={styles.filterFooter}>
                  <KFButton
                    color="primary"
                    disabled={isAppConfigsLoading || isFiltersLoading}
                    onClick={() => {
                      onApplyFilters();
                      hideFilterMenu();
                    }}
                  >
                    Apply Filter
                  </KFButton>
                  <KFButton
                    color="ghost"
                    disabled={isAppConfigsLoading || isFiltersLoading}
                    onClick={() => {
                      onCountryFilterApplied(selectedFilters.COUNTRY);
                      hideFilterMenu();
                    }}
                  >
                    Clear All
                  </KFButton>
                </div>
              </div>
            )}
          </div>
        </ClickAwayListener>
        <div className={styles.buttonGrup}>
          <KFButton
            color="quaternary"
            className={`${styles.btnLeft} ${
              pageView === PageView.CHART ? styles.btnActive : ""
            }`}
            onClick={() => {
              setPageView(PageView.CHART);
            }}
          >
            <ChartIcon />
          </KFButton>
          <KFButton
            color="quaternary"
            className={`${styles.btnRight} ${
              pageView === PageView.LIST ? styles.btnActive : ""
            }`}
            onClick={() => {
              setPageView(PageView.LIST);
            }}
          >
            <ListIcon />
          </KFButton>
        </div>
      </div>

      <div className={styles.tabContainer}>
        <Box>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            className="pa-tabs-wrapper"
            variant="scrollable"
            scrollButtons="auto"
            TabIndicatorProps={{
              children: <span className="MuiTabs-indicatorSpan" />
            }}
          >
            <Tab label={reports.headlinePayEquity.title} id="tab-1" />
            <Tab label={reports.variablePayReporting.title} id="tab-2" />
            <Tab label={reports.payEquityByJobLevel.title} id="tab-3" />
            <Tab label={reports.regressionAnalysis.title} id="tab-4" />
          </Tabs>
        </Box>
      </div>
      <TabPanelContent index={0} value={activeTab}>
        {activeTab === 0 && <HeadlinePayEquity pageView={pageView} />}
      </TabPanelContent>
      <TabPanelContent index={1} value={activeTab}>
        {activeTab === 1 && <VariablePayReporting pageView={pageView} />}
      </TabPanelContent>
      <TabPanelContent index={2} value={activeTab}>
        {activeTab === 2 && <PayEquityByJobLevel pageView={pageView} />}
      </TabPanelContent>
      <TabPanelContent index={3} value={activeTab}>
        <>Content 4</>
      </TabPanelContent>
    </div>
  );
  // return <KFErrorScreen errorType='forbidden' />;
};

export default ReportsPage;
